const setResumeBasics = (basics) => ({
    type: 'SET_RESUME_BASICS',
    basics,
});

export default setResumeBasics;
